<template>
  <b-form-row>
    <b-modal
        size="md"
        button-size="sm"
        hide-footer
        v-model="showModal"
        :title="prefix + title"
        @hidden="cancelar"
    >
      <b-form @submit.prevent="confirmarBloqueio">
        <b-card bg-variant="light">
          <lg-form-input
              invalidFeedback="Informe uma justificativa válida!"
              description=" "
              :error="$v.form.justificativa"
              v-model="form.justificativa"
              label="Justificativa:"
              cols="12"
          />

          <lg-form-input
              invalidFeedback="Informe uma mensagem válida!"
              description=" "
              :error="$v.form.mensagem"
              v-model="form.mensagem"
              label="Mensagem:"
              cols="12"
          />

          <b-form-row>
            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
              <b-button
                  id="confirmarBloqueio"
                  class="my-2"
                  size="sm"
                  pill
                  variant="success"
                  @click="confirmarBloqueio"
              >
                <b-icon icon="check-circle" />
                <b-tooltip target="confirmarBloqueio" title="Confirmar"></b-tooltip>
              </b-button>
              <b-button
                  id="cancelarBloqueio"
                  class="my-2 ml-2"
                  size="sm"
                  pill
                  variant="danger"
                  @click="cancelar"
              >
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelarBloqueio" title="Cancelar"></b-tooltip>
              </b-button>
            </b-col>
            <b-col cols="3"></b-col>
          </b-form-row>
        </b-card>
      </b-form>
    </b-modal>
  </b-form-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
  components: {
    LgFormInput,
  },
  props: {
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showModal: true,
      title: " Bloqueio/Desbloqueio do Almoxarifado",
      form: {
        justificativa: "",
        mensagem: "",
      },
    };
  },
  validations: {
    form: {
      justificativa: { required },
      mensagem: { required },
    },
  },
  methods: {
    confirmarBloqueio() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$notify({
          type: "danger",
          message: "Verifique os campos de cadastro.",
        });
        return;
      }
      this.$emit("confirmar", this.form);
      this.cancelar();
    },
    cancelar() {
      this.showModal = false;
      this.$emit("close");
    },
  },
};
</script>
